module.exports = __webpack_public_path__ + "img/T-Bane-Single.3eca3e18.svg";